<div class="white-bg-overlay">&nbsp;</div>
<section class="page-wrapper bg-white scroll-container">
  <div class="d-flex">
    <div class="me-auto">
      <h1 class="page-title">Client Search</h1>
    </div>
  </div>
  <input
    id="search-input"
    class="form-control"
    placeholder="Search for client ID, legal or DBA Name"
    [(ngModel)]="searchQuery"
    (keyup)="search()"
    autofocus
    autocomplete="off" />
  <div *ngIf="searchQuery.length < minSearchLength">
    <small>Enter at least {{ minSearchLength }} characters</small>
  </div>
  <div *ngIf="searchQuery.length >= minSearchLength && (!clients || clients.length === 0)">
    <em>No results found</em>
  </div>
  <div *ngIf="clients && clients.length > 0">
    <table class="table table-border">
      <thead>
        <tr>
          <th style="width: 50px"></th>
          <th>Name</th>
          <th>Company ID</th>
          <th>Legal Name</th>
          <th>Primary Contact</th>
          <th>Contact Email</th>
          <th>Contact Phone</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let client of clients">
          <td><i class="far fa-3x fa-building"></i></td>
          <td>
            <a (click)="navigateToClient(client.Id)">
              <strong>{{ client.DBA || client.Name }}</strong>
            </a>
          </td>
          <td>{{ client.Id }}</td>
          <td>{{ client.Name }}</td>
          <td>{{ client.PrimaryContact }}</td>
          <td>
            <a>{{ client.ContactEmail }}</a>
          </td>
          <td>{{ client.ContactPhone | mask: '(000) 000-0000' }}</td>
        </tr>
      </tbody>
    </table>
    <lib-pagination [pagination]="pagination" (pageChanged)="loadPage($event)"></lib-pagination>
  </div>
</section>
